import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "authenticate" }
const _hoisted_2 = { class: "authenticate-form" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("h3", null, "Behold!", -1)),
      _createElementVNode("a", {
        href: _ctx.googleLink,
        class: "btn-outline"
      }, "Google", 8, _hoisted_3),
      _createElementVNode("a", {
        href: _ctx.narnLink,
        class: "btn-outline"
      }, "narn.me", 8, _hoisted_4),
      _createElementVNode("a", {
        href: _ctx.yandexLink,
        class: "btn-outline"
      }, "Yandex", 8, _hoisted_5)
    ])
  ]))
}